import { testimonials } from '@/mocks/data';

export default function TestimonialsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          创作者说
        </h2>
        <p className="mt-2 text-sm text-foreground-500">听听社区成员的真实感受</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((item) => (
          <div key={item.name} className="bg-background-50 rounded-lg border border-background-200/70 p-6">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={item.avatar}
                alt={item.name}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                <div className="text-xs text-foreground-500">{item.role}</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
            <div className="flex items-center gap-1 mt-4 text-accent-500">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-sm"></i>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}